export const categories = [
  {
    id: 1,
    slug: 'yule',
    name: '娱乐休闲',
    icon: 'ri-movie-2-line',
    description: '视频、音乐、游戏、动漫等娱乐网站大全',
    color: 'primary',
  },
  {
    id: 2,
    slug: 'gouwu',
    name: '购物消费',
    icon: 'ri-shopping-bag-3-line',
    description: '电商购物、优惠券、比价等消费类网站',
    color: 'accent',
  },
  {
    id: 3,
    slug: 'xinwen',
    name: '新闻资讯',
    icon: 'ri-newspaper-line',
    description: '综合新闻、科技资讯、财经信息等新闻门户',
    color: 'secondary',
  },
  {
    id: 4,
    slug: 'gongju',
    name: '实用工具',
    icon: 'ri-tools-line',
    description: '在线工具、翻译、云盘、邮箱等实用服务',
    color: 'primary',
  },
  {
    id: 5,
    slug: 'xuexi',
    name: '学习教育',
    icon: 'ri-book-open-line',
    description: '在线课程、知识平台、学术资源等学习网站',
    color: 'accent',
  },
  {
    id: 6,
    slug: 'shejiao',
    name: '社交社区',
    icon: 'ri-group-line',
    description: '社交网络、论坛社区、博客等交流平台',
    color: 'secondary',
  },
  {
    id: 7,
    slug: 'shenghuo',
    name: '生活服务',
    icon: 'ri-heart-line',
    description: '美食、旅游、房产、健康等生活服务平台',
    color: 'primary',
  },
  {
    id: 8,
    slug: 'keji',
    name: '科技数码',
    icon: 'ri-smartphone-line',
    description: '科技资讯、数码产品、编程开发等科技网站',
    color: 'accent',
  },
  {
    id: 9,
    slug: 'caijing',
    name: '财经金融',
    icon: 'ri-funds-line',
    description: '银行、证券、保险、理财等金融财经网站',
    color: 'secondary',
  },
];

export const categoryColorMap: Record<string, { bg: string; text: string; badge: string; border: string; hover: string }> = {
  primary: {
    bg: 'bg-primary-100',
    text: 'text-primary-700',
    badge: 'bg-primary-500',
    border: 'border-primary-200',
    hover: 'hover:bg-primary-200/70',
  },
  accent: {
    bg: 'bg-accent-100',
    text: 'text-accent-700',
    badge: 'bg-accent-500',
    border: 'border-accent-200',
    hover: 'hover:bg-accent-200/70',
  },
  secondary: {
    bg: 'bg-secondary-100',
    text: 'text-secondary-700',
    badge: 'bg-secondary-500',
    border: 'border-secondary-200',
    hover: 'hover:bg-secondary-200/70',
  },
};